<!--
  ACRY アプリからの自動ログイン用エンドポイント

  ACRY 側で取得した Firebase IDトークンを GETパラメータ ?token=xxx で受け取り、
  Cloud Functions の ExchangeToken で Custom Token に変換してログインする。
  ログイン後は契約状態に応じて /home または /acryproform へリダイレクト。
  失敗時は / (ログイン画面) へフォールバック。
-->
<template>
  <div class="container-fluid">
    <Loading v-if="this.$store.state.isLoading" />
    <AlertDialog v-if="this.$store.state.isAlertDialog" />
  </div>
</template>

<script>
import router from "@/router";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/functions";
import { User } from "@/js/User.js";
import Loading from "@/components/modal/dialog/Loading.vue";
import AlertDialog from "@/components/acyrpro/modal/dialog/AlertDialog_Ap.vue";
import { Analytics } from "@/js/Analytics.js";
import { Logger } from "@/js/utils/Logger.js";
import { Device } from "@/js/utils/Device.js";

export default {
  name: "AcryApp",
  components: {
    Loading,
    AlertDialog,
  },
  async created() {
    this.$store.commit("showLoading");

    const idToken = this.$route.query.token;
    if (!idToken) {
      // tokenが渡されていなければログイン画面へ
      this.$store.commit("hideLoading");
      router.replace("/").catch(() => {});
      return;
    }

    try {
      // 既存のログイン状態をクリア（別ユーザーのトークンが来ても確実に切り替えるため）
      await firebase.auth().signOut().catch(() => {});

      // Cloud Functions で IDトークン → Custom Token へ交換
      const functions = firebase.app().functions("asia-northeast1");
      const exchange = functions.httpsCallable("ExchangeToken");
      const res = await exchange({ idToken });
      const customToken = res.data && res.data.customToken;
      if (!customToken) {
        throw new Error("customToken not returned");
      }

      // Custom Token でログイン
      await firebase.auth().signInWithCustomToken(customToken);

      // アナリティクス設定
      Analytics.setUserId(firebase.auth().currentUser.uid);
      Analytics.login("acry_app");

      // URLからtokenを除去（履歴・Refererに残さない）
      window.history.replaceState({}, "", "/acryapp");

      // 契約状態に応じて遷移先を決定
      const data = await User.getFBAcryProUserData();
      this.$store.commit("hideLoading");
      if (data && "isSendRequest" in data && data.isSendRequest) {
        // 情報登録済 → モバイルからはホーム未対応のためPC案内、PCはホームへ
        if (Device.isMobile()) {
          this.$store.commit("setAlertDialogCallback", async () => {
            await firebase.auth().signOut().catch(() => {});
            router.replace("/").catch(() => {});
          });
          this.$store.commit(
            "showMessage",
            "ご利用にはPCのブラウザからアクセスしてください。"
          );
        } else {
          router.replace("/home").catch(() => {});
        }
      } else {
        // 情報未登録 → スマホ用 登録&署名依頼画面
        router.replace("/acryappform").catch(() => {});
      }
    } catch (e) {
      Logger.warn("AcryApp login failed", e);
      this.$store.commit("hideLoading");
      router.replace("/").catch(() => {});
    }
  },
};
</script>
